import { Home } from "../components/Home"

export const HomePage = () => {
    return <Home />
}
